export const passwordMustContainText =
    'Password must contain at least 6 characters, including at least one uppercase letter, one lowercase letter, and one number';
export const tokenExpiredAndSendEmailText = "This link has been expired, We've sent you an email.";
export const tokenExpiredText = 'This link has been expired.';
export const setNewPasswordText = 'Set new password';
export const reEnterPasswordText = 'Re-enter password';
export const confirmPasswordText = 'Confirm password';
export const backToLoginText = 'Back to login';
export const containsUpperCaseText = 'Contains at least one uppercase letter';
export const containsLowerCaseText = 'Contains at least one lowercase letter';
export const containsNumberText = 'Contains at least one number';
export const minLengthText = 'At least 6 characters long';
